import React from "react";
import { FAQS } from "../../data/mock";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import Reveal from "./Reveal";

const FAQ = () => {
  return (
    <section className="faq-section" id="faq">
      <div className="container">
        <Reveal className="section-header">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">Got questions? We've got answers.</p>
        </Reveal>

        <Reveal className="faq-container" variant="up">
          <Accordion type="single" collapsible className="faq-accordion">
            {FAQS.map((faq) => (
              <AccordionItem key={faq.id} value={`item-${faq.id}`} className="faq-item">
                <AccordionTrigger className="faq-trigger">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="faq-answer">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default FAQ;
